import * as React from 'react'
import './index.scss'
import { connect } from "react-redux";
import { ActionType, merchantInfoType, reducerStoreType, storeType, CHAINTYPES, ROLES } from "../../reducers/types";
import { Dispatch } from "redux";
import PaymentSettings from "./PaymentSettings";
import Qrcodes from "./Qrcodes";
import { injectIntl, IntlShape } from 'react-intl'
import Grid from "@material-ui/core/Grid";

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  merchantInfo: merchantInfoType,
  role: ROLES,
  storeList: storeType[],
  currentStore: number,
  intl: IntlShape
}

class BasicInfo extends React.Component<IProps, {}> {
  handleFeeTypeChange = () => {
    this.props.dispatch({ type: 'PAY_SETTINGS_CHANGE', payload: { key: 'feeType' } })
  }
  saveMarkupRate = (value: string) => {
    let rate = Number(value) / 100
    this.props.dispatch({ type: 'PAY_SETTINGS_CHANGE', payload: { key: 'markupRate', value: rate } })
  }
  getQrcodes = () => {
    if (this.props.currentStore === -1) {
      return {
        qrcodeAlipayImg: this.props.merchantInfo.qrcodeAlipayImg,
        qrcodeWechatImg: this.props.merchantInfo.qrcodeWechatImg,
        qrodeImg: this.props.merchantInfo.qrodeImg
      }
    }
    for (var i = 0; i < this.props.storeList.length; i++) {
      if (this.props.storeList[i].storeId === this.props.currentStore) {
        return {
          qrcodeAlipayImg: this.props.storeList[i].qrcodeAlipayImg,
          qrcodeWechatImg: this.props.storeList[i].qrcodeWechatImg,
          qrodeImg: this.props.storeList[i].qrodeImg
        }
      }
    }
    return null
  }

  public render() {
    let { merchantInfo, intl } = this.props
    let qrcodes = this.getQrcodes()
    let role = this.props.role
    let isAdmin = (role === ROLES.SUPER_ADMIN ||
      (merchantInfo.chainType === CHAINTYPES.SINGLE && role !== ROLES.CASHIER))
    return (
      <div className="basicInfo">
        <div className="header">
          <h2>{intl.formatMessage({ id: 'merchantInfo' })}</h2>
        </div>
        <div className="infoMainContent">
          <div className="section-settings clear">
            <h3>{intl.formatMessage({ id: 'basicInfo' })}</h3>
            <Grid container className="content">
              <Grid item xs={6} className="info">
                <label>{intl.formatMessage({ id: 'company' })}</label>
                <span>{merchantInfo.name}</span>
              </Grid>
              <Grid item xs={6} className="info">
                <label>{intl.formatMessage({ id: 'country' })}:</label>
                <span>{merchantInfo.country}</span>
              </Grid>
              {/* <Grid item xs={6} className="info">
                                <label>{intl.formatMessage({id: 'payCurrency'})}:</label>
                                <span>{merchantInfo.currency}</span>
                            </Grid>
                            <Grid item xs={6} className="info">
                                <label>{intl.formatMessage({id: 'currency'})}:</label>
                                <span>{merchantInfo.orgCurrency}</span>
                            </Grid> */}
              {
                merchantInfo.exchangeFlag ? <Grid item xs={6} className="info">
                  <label>{intl.formatMessage({ id: 'exchangeRate' })}:</label>
                  <span>{merchantInfo.exchangeRate}</span>
                </Grid> : null
              }
              <Grid item xs={6} className="info">
                <label>{intl.formatMessage({ id: 'storeType' })}:</label>
                <span>{intl.formatMessage({ id: CHAINTYPES[merchantInfo.chainType] })}</span>
              </Grid>
              {isAdmin && Object.keys(merchantInfo.feeWallet).map(paymentType => {
                // 使用类型断言解决索引问题
                const paymentArray = (merchantInfo.feeWallet as any)[paymentType];
                if (!paymentArray || !Array.isArray(paymentArray)) {
                  return null;
                }
                return (
                  <React.Fragment key={paymentType}>
                    {/* 支付类型标题 */}
                    <Grid item xs={12} className="payment-type-header">
                      <h4 style={{
                        margin: '16px 0 8px 0',
                        color: '#333',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        borderBottom: '2px solid #e0e0e0',
                        paddingBottom: '8px',
                        textAlign: 'left'
                      }}>
                        {paymentType}
                      </h4>
                    </Grid>
                    {/* 该支付类型下的所有钱包费率 */}
                    {paymentArray.map((item: any, index: number) => (
                      <Grid item xs={6} className="info wallet-fee-item" key={`${paymentType}-${item.wallet}-${index}`}>
                        <label style={{ fontWeight: 'normal' }}>
                          {item.name || item.wallet}{intl.formatMessage({ id: 'fee' })}:
                        </label>
                        <span style={{ color: '#1976d2', fontWeight: 'bold' }}>
                          {(item.feeRate * 100).toFixed(2)}%
                        </span>
                      </Grid>
                    ))}
                    {/* 添加分隔线，除了最后一个 */}
                    {Object.keys(merchantInfo.feeWallet).indexOf(paymentType) < Object.keys(merchantInfo.feeWallet).length - 1 && (
                      <Grid item xs={12} style={{ margin: '8px 0' }}>
                        <div style={{ borderTop: '1px solid #f0f0f0' }}></div>
                      </Grid>
                    )}
                  </React.Fragment>
                );
              })}
              {/*{isAdmin && merchantInfo.walletList.map((wallet, i) => {*/}
              {/*    return (<Grid item xs={6}  className="info" key={`wallet-${wallet}-${i}`}>*/}
              {/*        <label>{wallet.wallet}{intl.formatMessage({id: 'fee'})}:</label>*/}
              {/*        <span>{wallet.feeRate * 100}%</span>*/}
              {/*    </Grid>)*/}
              {/*})}*/}
            </Grid>
          </div>
          {isAdmin ?
            <PaymentSettings feeType={merchantInfo.feeType}
              markupRate={merchantInfo.markupRate}
              exchangeFlag={merchantInfo.exchangeFlag}
              key={`${merchantInfo.name}-${merchantInfo.markupRate}`}
              handleFeeTypeChange={this.handleFeeTypeChange}
              saveMarkupRate={this.saveMarkupRate} />
            : null}
          {qrcodes ?
            <Qrcodes {...qrcodes} /> : null}
        </div>
      </div>
    );
  }
}

export default injectIntl(connect((state: reducerStoreType) => {
  return {
    merchantInfo: state.merchant.merchantInfo,
    role: state.app.userInfo ? state.app.userInfo.role : ROLES.NONE,
    storeList: state.merchant.storeList,
    currentStore: state.app.currentStore
  }
})(BasicInfo))
